export default __webpack_public_path__ + "static/spamonkeys-logo.00ee4a6d.svg";